export interface BatchSchoolLendCollectionListRequest {
  grade: string
  class: string
  lendDateFrom: string
  lendDateTo: string
  userId: string
  displayFullName: boolean
  outputJournal: boolean
  outputGroupByUserId: boolean
  outputOrder: string
  batchType: string
}

export function BatchSchoolLendCollectionListRequestToJSON(
  value: BatchSchoolLendCollectionListRequest
): any {
  return {
    grade: value.grade,
    class: value.class,
    lend_date_from: value.lendDateFrom,
    lend_date_to: value.lendDateTo,
    user_id: value.userId,
    display_full_name: value.displayFullName,
    output_journal: value.outputJournal,
    output_group_by_user_id: value.outputGroupByUserId,
    output_order: value.outputOrder,
    batch_type: value.batchType
  }
}
